export default __webpack_public_path__ + "medical_mb7780d.jpg";